import Vue from "vue";
import moment from 'moment'
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCropper from 'vue-cropper'
import utils from "@/utils/utils";
import validator from "@/utils/validator";
import enums from '@/utils/enums'
import api from "@/api";
import wxApi from "@/api/wxWork";
import device from '@/utils/device'
import '@/utils/storage'
import message from '@/utils/message'
import messageBox from '@/utils/messageBox'
import Sort from '@/plugins/sort'
import StatCard from '@/plugins/statCard'
import "@/styles/override.scss";
import "@/styles/common.scss";
import "@/directives";
import "@/filters";
// import '@/mock'

ElementUI.Select.props.popperAppendToBody = {
  type: Boolean,
  default: false
}
ElementUI.Cascader.props.appendToBody = {
  type: Boolean,
  default: false
}
ElementUI.DropdownMenu.props.appendToBody = {
  type: Boolean,
  default: false
}

Vue.use(ElementUI);
Vue.use(VueCropper)
Object.entries(enums).forEach(([key, val]) => {
  Vue.prototype[`$${key}`] = val
})

Vue.prototype.$utils = utils;
Vue.prototype.$validator = validator;
Vue.prototype.$api = api;
Vue.prototype.$wxApi = wxApi;
Vue.prototype.$device = device;
Vue.prototype.$moment = moment;
Vue.prototype.$message = message.message
Vue.prototype.$message.success = message.success
Vue.prototype.$message.error = message.error
Vue.prototype.$msgbox = messageBox.messageBox
Vue.prototype.$confirm = messageBox.confirm;
Vue.prototype.$alert = messageBox.alert;

Vue.use(Sort)
Vue.use(StatCard)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
